import type { BibleBookId, BibleManifest } from "@packages/sdk";
import { ChevronDownIcon, useModal } from "@packages/ui";
import { Button } from "@packages/ui/src/components/_base/_core/Button/Button.emotion";
import type { PropsWithChildren } from "react";
import { forwardRef } from "react";

import { BibleNavBooks } from "../BibleNavigation/BibleNavBooks";

export const BibleChapterHeader = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<{ book: BibleBookId; manifest: BibleManifest }>
>(({ book, manifest, children }, titleRef) => {
  const nav = useModal(BibleNavBooks);
  return (
    <Button
      ref={titleRef}
      endIcon={<ChevronDownIcon />}
      variant="transparentPrimary"
      onClick={() => nav.show({ book, manifest })}
    >
      {children}
    </Button>
  );
});
